export default function formatNumberWithSpaces(number, truncate = 8) {
  if (typeof number !== "number" && typeof number !== "string") {
    throw new Error(
      "Input must be a number or a string representation of a number.",
    );
  }

  if (number === 0) {
    return "0";
  }

  // Convert to fixed decimal places first
  const num = Number(number || 0).toFixed(truncate);

  // Split into integer and decimal parts
  const [integerPart, decimalPart] = num.split(".");

  // Format integer part with spaces
  const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

  // Remove trailing zeros from decimal part
  const trimmedDecimal = decimalPart ? decimalPart.replace(/0+$/, "") : "";

  // Return formatted number with or without decimal part
  return trimmedDecimal
    ? `${formattedInteger}.${trimmedDecimal}`
    : formattedInteger;
}
